"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.emitUpdate = exports.emitOn = exports.emit = exports.extendFrom = exports.component = exports.componentFactoryOf = exports.componentFactory = exports.withPropsObject = exports.withUnknownProps = exports.withHtmlAttrs = exports.withNativeOn = exports.ofType = exports.createComponent = exports.Component = void 0;
var vue_1 = __importDefault(require("vue"));
var Component = /** @class */ (function (_super) {
    __extends(Component, _super);
    function Component() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Component;
}(vue_1.default));
exports.Component = Component;
/**
 * Create component from component options (Compatible with Vue.extend)
 */
function createComponent(opts) {
    return vue_1.default.extend(opts);
}
exports.createComponent = createComponent;
var factoryImpl = {
    convert: function (c) { return c; },
    extendFrom: function (c) { return c; }
};
/**
 * Specify Props and Event types of component
 *
 * Usage:
 *  // Get TSX-supported component with props(`name`, `value`) and event(`onInput`)
 *  const NewComponent = tsx.ofType<{ name: string, value: string }, { onInput: string }>.convert(Component);
 */
function ofType() {
    return factoryImpl;
}
exports.ofType = ofType;
function withNativeOn(componentType) {
    return componentType;
}
exports.withNativeOn = withNativeOn;
function withHtmlAttrs(componentType) {
    return componentType;
}
exports.withHtmlAttrs = withHtmlAttrs;
function withUnknownProps(componentType) {
    return componentType;
}
exports.withUnknownProps = withUnknownProps;
function withPropsObject(componentType) {
    return componentType;
}
exports.withPropsObject = withPropsObject;
function createComponentFactory(base, mixins) {
    return {
        create: function (options) {
            var mergedMixins = options.mixins ? __spreadArrays(options.mixins, mixins) : mixins;
            return base.extend(__assign(__assign({}, options), { mixins: mergedMixins }));
        },
        mixin: function (mixinObject) {
            return createComponentFactory(base, __spreadArrays(mixins, [mixinObject]));
        }
    };
}
function createExtendableComponentFactory() {
    return {
        create: function (options) {
            return vue_1.default.extend(options);
        },
        extendFrom: function (base) {
            return createComponentFactory(base, []);
        },
        mixin: function (mixinObject) {
            return createComponentFactory(vue_1.default, [mixinObject]);
        }
    };
}
exports.componentFactory = createExtendableComponentFactory();
function componentFactoryOf() {
    return exports.componentFactory;
}
exports.componentFactoryOf = componentFactoryOf;
/**
 * Shorthand of `componentFactory.create`
 */
exports.component = exports.componentFactory.create;
exports.extendFrom = exports.componentFactory.extendFrom;
function emit(vm, name) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    vm.$emit.apply(vm, __spreadArrays([name], args));
}
exports.emit = emit;
function emitOn(vm, name) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    vm.$emit.apply(vm, __spreadArrays([name.replace(/^on[A-Z]/, function (v) { return v[2].toLowerCase(); })], args));
}
exports.emitOn = emitOn;
function emitUpdate(vm, name, value) {
    vm.$emit("update:" + name, value);
}
exports.emitUpdate = emitUpdate;
//# sourceMappingURL=data:application/json;base64,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